import { Grid, TextField } from '@mui/material'
import React from 'react'

const LogoColor = ({ companySettings, setCompanySettings }) => (
  <Grid item xs={12} container spacing={1}>
    <Grid item xs={12} lg={6}>
      <TextField
        value={companySettings?.logobackgroundColor ?? '#ffffff'}
        onChange={(e) =>
          setCompanySettings((prev) => ({
            ...prev,
            logobackgroundColor: e.target.value,
          }))
        }
        fullWidth
        type="color"
        label="Logo Background Colour"
        helperText="Shown behind your logo in the app header"
        // The native colour input collapses to a sliver inside a TextField —
        // give the swatch a real height
        sx={{ '& input[type="color"]': { height: 45, padding: 0.75, cursor: 'pointer' } }}
      />
    </Grid>
  </Grid>
)

export default LogoColor
